import data from "../../data/index.json";

export default function MySkills() {
  return (
    <section className="skills--section" id="MySkills">
      <div className="portfolio--container">
        <h2 className="skills--section--heading">Skills</h2>
      </div>
      <div className="skills--section--container custom-skills-height">
        {data?.skills?.map((item, index) => (
          <div key={index} className="skills--section--card">
            <div className="skills--section--img">
              <img src={item.src} alt="Product Chain" style={{ width: '60px', height: '60px' }} />
            </div>
            <div className="skills--section--card--content">
              <h3 className="skills--section--title">{item.title}</h3>
              <p id="description" className="skills--section--description" dangerouslySetInnerHTML={{ __html: item.description }}/>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
